var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import ApplicationInstance from "@ember/application/instance";
import { getOwner } from "@ember/owner";
import Service, { service } from "@ember/service";
import { tracked } from "@glimmer/tracking";
let ParogService = (_class = class ParogService extends Service {
  constructor(owner) {
    super(owner);
    _initializerDefineProperty(this, "_wiser", _descriptor, this);
    _initializerDefineProperty(this, "store", _descriptor2, this);
    _defineProperty(this, "ENV", void 0);
    this.ENV = getOwner(this).resolveRegistration("config:environment");
    this._wiser = this.ENV.wiser;
  }

  /**
   * Version of the app, automatically updated when releasing
   */
  get version() {
    return this.ENV.APP.version;
  }
  get conf() {
    return this.ENV.parog;
  }
  get wiser() {
    return this._wiser;
  }
  set wiser(flag) {
    this._wiser = flag;
  }

  /**
   * Called when a medic wants to display a completed form from the timeline.
   * If you don't want to display the collected data in the form used during the initial completion, return another one.
   * @param formId initially used to complete the form
   * @returns The formId used to display the form
   */
  formIdToDisplayFromTimeline(formId) {
    return formId;
  }

  /**
   * Called when a patient is created.
   */

  patientCreated(/*patient*/) {}

  /**
   * Called when a medic wants to edit a form. The form from which the medic switches to edit mode
   * is not always the one used for displaying the form (related to `formIdToDisplayFromTimeline`).
   * @param formId used to display the form
   * @returns The formId wanted for the edition
   */
  formIdForEdition(formId) {
    return formId;
  }

  /**
   * Hook called when a form is saved.
   */

  formSaved(/*{ form, payload, context }*/) {}
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "_wiser", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { ParogService as default };